import { axios } from 'shared/services/axios'

export function getEmailVerificationInfo (authId) {
  return axios.get(`/authorization/v1/access_authorizations/${authId}/email_verification`)
    .then(response => response.data)
}

export function sendEmailVerification (authId, email) {
  return axios.post(`/authorization/v1/access_authorizations/${authId}/email_verification`, {
    email
  }).then(response => response.data)
}

export function verifyEmailCode (authId, verificationCode) {
  return axios.get(`/authorization/v1/access_authorizations/${authId}/email_verification/verify`, {
    params: { verification_code: verificationCode }
  }).then(response => response.data)
}
